import { Box } from "@mui/material";
import { Position } from "reactflow";
import { INodeData } from "../../index";
import CustomHandler from "../../Helpers/CustomHandler";

export default function NodeFim({ data }: INodeData) {
    return (
        <>
            <Box
                bgcolor="#dc3545"
                border={`2px solid rgba(0,0,0, ${data.isClicked ? "0.7" : "0.2"})`}
                width={60}
                height={60}
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="50%"
                color="#fff"
            >
                Fim
            </Box>
            <CustomHandler type="target" id="target-left" position={Position.Left} />
            <CustomHandler type="target" id="target-top" position={Position.Top} />
            <CustomHandler type="target" id="target-right" position={Position.Right} />
            <CustomHandler type="target" id="target-bottom" position={Position.Bottom} />
        </>
    )
}